<ng-container *transloco="let t; read: 'travel-dates'">
  <ng-container [formGroup]="qqcForm" *ngIf="qqcForm">
    <fieldset id="qqc-travel-dates-fieldset">
      <legend id="qqc-travel-dates-legend" class="legend-caption">
        {{ t('dateLabel') }}
      </legend>
      <div id="qqc-travel-dates-wrapper">
        <nibtravel-date-picker
          [e2eId]="e2eId.TravelDate"
          [type]="datePickerConfig.type"
          [labels]="datePickerConfig.labels"
          [settings]="datePickerConfig.settings"
          [formGroup]="qqcForm"
          [controlName]="datePickerConfig.controlName"
          [validations]="datePickerConfig.validations"
          [validationLabel]="datePickerConfig.validationLabel"
          placeholder="Mon, 6 July 2022"
          *ngIf="isSetupReady$ | async"
          [startDatePlaceHolder]="startDatePlaceHolder"
          [departureDatePlaceHolder]="departureDatePlaceHolder"
        ></nibtravel-date-picker>
      </div>
      <div id="qqc-waiting-period" *ngIf="showWaitingAlert">
        <nibtravel-alert [type]="AlertType.WARNING" [title]="t('alertTitle')">
          <p>
            {{ t('alertMessage', { waitingPeriodHours: waitingPeriodHours }) }}
          </p>
        </nibtravel-alert>
      </div>
    </fieldset>
  </ng-container>
</ng-container>
